<!-- prettier-ignore -->

<!-- @if(this.route()){ -->
    <div class="form-container" [ngClass]="{'reverse': userData()?.id}">
        @if(!userData()?.id){
            @if(pdfsByCategories()?.length > 0){
                <cicerone-add-pdf [categories]="pdfsByCategories()"></cicerone-add-pdf>
            }
            <send-route [isSaveRoute]="authService.userValue"></send-route>
        }
       @else {
            @if(showAddPDFsList()){
                @if(pdfsByCategories()?.length > 0){
                    <cicerone-add-pdf [categories]="pdfsByCategories()" [showBackButton]="true"></cicerone-add-pdf>
                }
            }
            @else {
                @if(allPdfs()?.length > 0){
                    <cicerone-list-pdf [pdfs]="allPdfs()"></cicerone-list-pdf>
                }
            }
            <cicerone-update-route [isSaveRoute]="authService.userValue"></cicerone-update-route>
       }   
    </div>
<!-- } -->